
import { Component, EventEmitter, Output, Input, OnInit, NgModule } from '@angular/core';

import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NotificationDto } from '../../../core/services/notification.service';
import { FormsModule, NgModel } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-header',
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  headerTitle: string = 'Dashboard';

  // Define route titles based on your routes
  // routeTitles: { [key: string]: string } = {
  //   'auth/login': 'Login',
  //   '/workers-requests': 'Worker Requests',
  //   '/apartment-list': 'Apartment List',
  //   '/worker-details': 'Worker Details',
  //   '/dashboard': 'Dashboard',
  //   '/staff-list': 'Staff List',
  //   '/staff-details': 'Staff Details',
  //   '/create-staff': 'Create Staff',
  //   '/staff-jobs': 'Assigned jobs',
  //   '/update-staff': 'Update Staff',

  //   '/issues-list': 'Issues List',
  //   '/create-issue': 'Create Issue',
  //   '/issue-details': 'Issue Details',
  //   '/update-issue': 'Update Issue',
    


  // };

  routeTitles: { [key: string]: string } = {
  'auth/login': 'Login',
  '/dashboard': 'Dashboard',

  // Sales
  '/sales/list': 'Manage Sales',
  '/sales/details/:id': 'Manage Sales',
  '/sales/add-new': 'Manage Sales',
  // offers
  '/offers/list': 'Offers',
  '/offers/details': 'Offers',
   // faq
  '/faq/list': 'FAQ',
  '/faq/add': 'FAQ',
  '/faq/update/:id': 'FAQ',

  //Renewal requests
   '/extend-booking/list': 'Renewal requests',
  '/extend-booking/details/:id': 'Renewal requests',
  

  //worker
  '/workwe-section/list': 'Workers List',
   

  // Tasks
  '/task/list': 'Tasks List',
  '/task/create-task': 'Create Task',
  '/task/task-details/:id': 'Task Details',


  // Problem
  '/problem/list': 'Problem List',
  '/problem/problem-details/:id': 'Problem Details',

   // admin
  '/admin/list': 'Admin List',
  '/admin/admin-details/:id': 'Admin Details',
  '/admin/add-new-admin': 'Add Admin',

 // worker report
  '/worker-report/list': 'Worker Reports List',
  '/worker-report/details/:id': 'Report Details',

   // worker section
  '/worker-section/list': 'Workers List',
  // '/worker-section/details/:id': 'Worker Details',

  //transaction list 
  '/transaction/list': 'Transaction List',
  '/transaction/transaction-details/:id': 'Transaction Details',

  //message
  '/message/main-page' : 'Messages'

  
   

 
};

  // Method to update the header title based on the route
  // updateTitle(url: string): void {

  //   const baseRoute = url.split('/')[1];
  //   const routeKey = `/${baseRoute}`;

  //   this.headerTitle = this.routeTitles[routeKey] || 'Dashboard';
  // }
  // updateTitle(url: string): void {
     
  //   const pathWithoutQuery = url.split('?')[0];
 
  //   const baseRoute = pathWithoutQuery.split('/')[1];

   
  //   const routeKey = `/${baseRoute}`;
 
  //   this.headerTitle = this.routeTitles[routeKey] || 'Dashboard';
  // }

 


updateTitle(url: string): void {
  const pathWithoutQuery = url.split('?')[0];

  // split إلى أجزاء
  const parts = pathWithoutQuery.split('/').filter(p => p);

  // ابني base route
  let routeKey = '/' + parts.join('/');

  // لو فيه id → شيله
  if (parts.length > 2) {
    routeKey = `/${parts[0]}/${parts[1]}/:id`;
  } else if (parts.length === 2) {
    routeKey = `/${parts[0]}/${parts[1]}`;
  } else if (parts.length === 1) {
    routeKey = `/${parts[0]}`;
  }

  console.log('Resolved route key:', routeKey);

  this.headerTitle = this.routeTitles[routeKey] || 'Dashboard';
}



  @Output() toggleSidebar = new EventEmitter<void>(); // Event to toggle sidebar visibility

  onToggleSidebar() {
    this.toggleSidebar.emit();
  }



  //////////////////////////////////////////////////
  value: string = '';
  show: string = 'false';
  @Output() newItemEvent = new EventEmitter<string>();
  @Input() titleModule = '';

userName:any;
initials:any;
firstName:any;
  constructor(private router: Router) {}
  ngOnInit() {
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      this.updateTitle(event.urlAfterRedirects);
    });
   
      //////////////////////////////////////////////////
  const userData = localStorage.getItem('user');
  const fullName = userData ? JSON.parse(userData).user.fullName: '';
  this.userName = fullName;
    console.log(this.userName )
  
  const nameParts = fullName.split(' ');
  this.initials = nameParts[0]?.charAt(0).toUpperCase() + (nameParts[1]?.charAt(0).toUpperCase() || '');
  this.firstName = nameParts[0];
    console.log(this.userName, this.firstName, this.initials)
  // this.firstName=this.userName.account_Type

///////////////////////////////////////////////////
  }
  showSidebar(): void {
    this.show == 'false' ? (this.show = 'true') : (this.show = 'false');
    this.newItemEvent.emit(this.show);
  }

  
  
   
 /////////notification//////////
  @Input() notifications: NotificationDto[] = [];
  @Input() unreadCount: number = 0;

  @Output() notificationRead = new EventEmitter<string>();

  showDropdown = false;
   
     toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
  }
 
  
  onClickNotification(n: NotificationDto): void {

    if(n.module==='Offer'){
      this.router.navigate(['/offers/details', n.module_ID]);
    }else if(n.module === 'ExtendRequests'){
      this.router.navigate(['/extend-booking/details', n.module_ID]);

    }else{
      this.router.navigate(['/message/main-page']);

    }
    
    
 // ابعتي للـ AppComponent إن الإشعار ده اتقرا
    this.notificationRead.emit(n.id);
  }
}
